module.exports = __webpack_public_path__ + "static/img/mvix.f9c1ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mvix.png
// module id = aFN4
// module chunks = 1